// ---------------------------------------------------------------------------
// Prezio Onboard Widget — cn (class name merger)
// ---------------------------------------------------------------------------
// Tiny utility to merge CSS class names. No clsx dependency needed.
// ---------------------------------------------------------------------------

export function cn(...args: (string | false | null | undefined)[]): string {
  return args.filter(Boolean).join(' ');
}
